export default (benefitData) => {
  const benefit = benefitData.selectedBenefit;
  const values = benefit.values;
  return {
    event: 'Tier Benefits',
    TierProd: benefit.tierProd, // seats or baggage
    TierLvl: benefit.tierLvl, // yes or no if seat/baggage is added
    TierCard: benefit.tierCard,
    pnr: values.pnrCode,
    route: values.route,
    labelFlightNumber: values.labelFlightNumber,
    ffProgram: values.ffProgram,
    DepartureTime: values.flightWindow,
    quantity: values.quantity, 
    passengers: values.passengers, 
    ticketNumber: values.ticketNumber, 
    flightDate:values.flightDate,   

  };
};
